import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { guard, user } from '../../../store/global-slice';
import { useHistory, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useService } from '../../../services/services';
import { useTranslation } from 'react-i18next';
import css from './index.module.css';
import { INTERNAL_DASHBOARD } from '../../../router/routes';
import { concatMap, finalize } from 'rxjs/operators';
import Spinner from '../../../components/common/spinner';

export default function Login() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { state } = useLocation<any>();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState } = useForm({
    mode: 'onChange',
    defaultValues: { username: '', password: '' },
  });
  const { isValid } = formState;
  const { internalAuthService } = useService();

  const [error, setError] = useState<string>(null);

  const submit = useCallback(
    (data: { username: string; password: string }) => {
      setLoading(true);

      const $subscription = internalAuthService
        .csrf()
        .pipe(
          concatMap(() =>
            internalAuthService.login(data.username, data.password)
          ),
          concatMap(() => internalAuthService.user()),
          finalize(() => setLoading(false))
        )
        .subscribe(
          (response) => {
            dispatch(guard('ldap'));
            dispatch(user(response));

            // TODO - Figure out why redirect to previous works only some time.
            history.push(state?.from?.pathname || INTERNAL_DASHBOARD);
          },
          (error) => {
            if (error?.response?.error) {
              setError(error.response.error);
            }
          }
        );

      return () => $subscription.unsubscribe();
    },
    [setLoading, internalAuthService, history, state, dispatch]
  );

  return (
    <div className={css['container']}>
      <form onSubmit={handleSubmit(submit)}>
        <h1>Mans Lauks</h1>

        {error && (
          <div className={css['error']}>
            {t('pages.internal.login.' + error)}
          </div>
        )}

        <div className={css['field']}>
          <label htmlFor="username">{t('username')}:</label>
          <input
            type="text"
            id="username"
            name="username"
            className={css['input']}
            {...register('username', { required: true })}
          />
        </div>
        <div className={css['field']}>
          <label htmlFor="password">{t('password')}:</label>
          <input
            type="password"
            id="password"
            name="password"
            className={css['input']}
            {...register('password', { required: true })}
          />
        </div>
        <div className={css['buttons']}>
          <button
            type="submit"
            className={css['button']}
            disabled={!isValid || loading}
          >
            <Spinner visible={loading} className={css['spinner']} />
            {t('Login')}
          </button>
        </div>
      </form>
    </div>
  );
}
